import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import HomeV2 from "./pages/HomeV2";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Cookies from "./pages/Cookies";
import Terms from "./pages/Terms";
import Sitemap from "./pages/Sitemap";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { AuthContext } from "./context/AuthProvider";
import HeaderV2 from "./components/HeaderV2";
import FooterV2 from "./components/FooterV2";
import DebugConfig from "./components/DebugConfig";
import "./App.css";

function App() {
  const { user, logout } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <Router>
      <DebugConfig />
      <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <HeaderV2 />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomeV2 />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/contacto" element={<Contact />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/mapa-sitio" element={<Sitemap />} />
            {process.env.REACT_APP_LOGIN === '1' && (
              user ? (
                <Route path="/dashboard" element={<Dashboard />} />
              ) : (
                <Route path="/login" element={<Login />} />
              )
            )}
          </Routes>
        </main>

        <FooterV2 />
      </div>
    </Router>
  );
}

export default App;